var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
export var NotFound = function () {
    return (_jsxs("article", __assign({ style: { padding: '100px' } }, { children: [_jsx("h1", { children: "Oops!" }), _jsx("p", { children: "Page Not Found" }), _jsx("div", { children: _jsx(Link, __assign({ to: "/" }, { children: "Visit Our Homepage" })) })] })));
};
